import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import TagManager from "react-gtm-module";
import { ensureDataLayer } from "./services/analytics.service";

const tagManagerArgs = {
  gtmId: "GTM-WLW7TXC",
};

ensureDataLayer();
TagManager.initialize(tagManagerArgs);
// Put your GA4 Measurement ID here

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
